import { render, staticRenderFns } from "./SendMsgPopup.vue?vue&type=template&id=2dcb4b97&"
import script from "./SendMsgPopup.vue?vue&type=script&lang=js&"
export * from "./SendMsgPopup.vue?vue&type=script&lang=js&"
import style0 from "./SendMsgPopup.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports